<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import PopupService from '../../../../domain/popup/services/popup'
  import { isEmpty } from 'lodash'
  import {fileToBase64} from '../../../_default/utils/fileToBase64'

  export default {
    name: 'novo-popup',
    directives: {mask},
    data () {
      return {
        popup: {
          nome: '',
          dataExibicao: '',
          dataExpiracao: '',
          situacao: true,
          url: ''
        },
        dataExibicao: '',
        horaExibicao: '',
        dataExpiracao: '',
        horaExpiracao: '',
        isLoading: false,
        isRegistering: false,
        formData: null,
        errorMsg: '',
        arquivo: ''
      }
    },
    computed: {
      dataExib () {
        return this.dataExibicao.replace(/-/g, '/') + ' ' + this.horaExibicao + ':00'
      },
      dataExp () {
        return this.dataExpiracao.replace(/-/g, '/') + ' ' + this.horaExpiracao + ':00'
      },
      areDatesValid () {
        return (new Date(this.dataExib) < new Date(this.dataExp))
      },
      notEmptyDates () {
        return !isEmpty(this.dataExibicao) && !isEmpty(this.horaExibicao) && !isEmpty(this.dataExpiracao) && !isEmpty(this.horaExpiracao)
      },
      isPopupValid () {
        return !isEmpty(this.popup.nome) && this.notEmptyDates
      },
      isValid () {
        return this.areDatesValid && this.isPopupValid // && (this.formData !== null)
      }
    },
    created () {
      if (this.$route.params.id) {
        this.getPopup()
      }
    },
    mounted () {
      this.$refs.inptNome.focus()
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      getPopup () {
        this.isLoading = true
        PopupService.getPopup(this.$route.params.id)
          .then(result => {
            console.log(result.data)
            this.popup = result.data
            let tmp = this.convertDataHora(this.popup.dataExibicao.date)
            this.dataExibicao = tmp[0]
            this.horaExibicao = tmp[1]
            tmp = this.convertDataHora(this.popup.dataExpiracao.date)
            this.dataExpiracao = tmp[0]
            this.horaExpiracao = tmp[1]
            tmp = null
          })
      },
      convertDataHora (date) { // TODO: MELHORAR
        // "2018-06-30 14:30:00.000000"
        let tmp = date.split(' ')
        let data = tmp[0]
        let hora = tmp[1].match(/^\d{2}:\d{2}/)
        return [data, hora[0]]
      },
      abreFileInput () {
        this.$refs.uploadFile.click()
      },
      setFile: async function (event) {
        let arquivo = event.target.files[0]

        try {
          this.arquivo = await fileToBase64(arquivo)

          document.getElementById('fileInpt').value = ''
        } catch (e) {
          alert('Ocorreu um problema ao selecionar o arquivo de imagem')
          console.log(e)
        }
      },
      submit () {
        this.isRegistering = true
        this.isLoading = true
        this.errorMsg = ''
        this.popup.dataExibicao = this.dataExib
        this.popup.dataExpiracao = this.dataExp
        const fn = this.$route.params.id ? PopupService.updatePopup(this.$route.params.id, this.popup) : PopupService.registerPopup(this.popup)
        fn.then(result => {
          if (this.arquivo) {
            PopupService.uploadFile({data: this.arquivo, filename: 'popup'}, result.data.id)
              .then(result => {
                console.log(result.data)
                this.isRegistering = false
                let tmp = this.url
                let d = new Date()
                this.url = ''
                this.url = tmp + '?' + d.getTime()
                this.reset()
                this.$router.push({name: 'popup.lista', query: {sucesso: 1}})
              })
              .catch(error => {
                console.log('erro aqui', error.response.data.error)
                if (error.response.status === 400) {
                  this.isRegistering = false
                  this.errorMsg = 'Houve um erro com a imagem. Tente novamente'
                  this.erro = error.response.data.errors
                }
              })
          } else {
            this.$router.push({name: 'popup.lista', query: {sucesso: 1}})
          }
        })
          .catch(error => {
            alert('Ocorreu um erro ao registrar o popup. Tente novamente')
            this.reset()
            console.log(error.response.data.error)
          })
      },
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      reset () {
        this.popup = {
          nome: '',
          dataExibicao: '',
          dataExpiracao: '',
          situacao: true,
          url: ''
        }
        this.dataExibicao = ''
        this.horaExibicao = ''
        this.dataExpiracao = ''
        this.horaExpiracao = ''
        this.isLoading = false
        this.isRegistering = false
        this.formData = null
      },
      cancel () {
        this.reset()
        this.$router.push({ name: 'popups' })
      },
      resetImg () {
        this.arquivo = ''
        this.formData = null
      }
    }
  }
</script>

<template>
  <div>
    <div class="app-content-body ">
      <div class="bg-light lter b-b wrapper-md">
        <h1 class="m-n font-thin h3">Cadastro de Pop-up</h1>
      </div>
      <span class="info-msg" v-if="isRegistering && !errorMsg">{{ isRegistering ? 'Cadastrando pop-up...' : '' }}</span>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <form @submit.prevent="">
            <div class="form-group wrapper-md">
              <div class="row m-b-md">
                <div class="col-md-7">
                  <label for="nome" ref="inptNome" class="control-label">Nome</label>
                  <input id="nome" type="text" class="form-control" v-model="popup.nome">
                </div>
                <div class="col-md-5">
                  <label for="url" class="control-label">Url</label>
                  <input id="url" type="text" class="form-control" placeholder="http://example.com" v-model="popup.url">
                </div>
              </div><!-- Fim Row -->
              <div class="row m-b-md">
                <div class="col-md-3">
                  <label for="dataExibicao" class="control-label">Data Exibição</label>
                  <input id="dataExibicao" type="date" class="form-control" v-model="dataExibicao">
                </div>
                <div class="col-md-3">
                  <label for="horarioExibicao" class="control-label">Horário Exibição</label>
                  <input id="horarioExibicao" type="time" class="form-control" v-model="horaExibicao">
                </div>
                <div class="col-md-3">
                  <label for="dataExpiracao" class="control-label">Data Expiração</label>
                  <input id="dataExpiracao" type="date" class="form-control" v-model="dataExpiracao">
                </div>
                <div class="col-md-3">
                  <label for="horarioExpiracao" class="control-label">Horário Expiração</label>
                  <input id="horarioExpiracao" type="time" class="form-control" v-model="horaExpiracao">
                </div>
              </div>
              <div class="row m-b-md" style="margin-left: 0px" v-if="!areDatesValid && notEmptyDates"><span class="text-red">Data/hora de expiração deve ser superior à de exibição</span></div>
              <div class="row m-b-md">
                <div class="col-md-4">
                  <label for="situacao" class="control-label">Situação</label>
                  <select id="situacao" name="account" class="form-control m-b" v-model="popup.situacao">
                    <option :value="true">Ativo</option>
                    <option :value="false">Inativo</option>
                  </select>
                </div>
                <div class="col-md-4 m-t-md">
                  <button class="btn btn-success" @click="abreFileInput" :disabled="isRegistering">Cadastrar imagem</button>
                  <div>Arquivo selecionado: <button class="btn btn-default btn-xs" @click="resetImg" v-if="arquivo">Limpar imagem selecionada</button><!--<strong>{{ arquivo }}</strong>--></div>
                  <img :src="arquivo || popup.imageInfo.thumb.url" alt="popup-thumb" v-if="arquivo || popup.imageInfo">
                  <input type="file" id="fileInpt" ref="uploadFile" accept="image/*" v-show="false" @change="setFile($event)"><br>
                  <span class="text-red" v-if="!errorMsg">{{ errorMsg }}</span>
                </div>
              </div><!-- Fim Row -->
              <div class="row m-b-xs">

              </div><!-- Fim Row -->
              <hr>
              <div class="wrapper-md">
                <div class="row">
                  <button class="btn w-xs btn-info" type="button" @click="submit()" :disabled="isRegistering || !isValid">{{ isRegistering ? 'Aguarde...' : 'Cadastrar' }}</button>
                  <button class="btn w-xs m-r-md btn-default" @click="cancel()">Cancelar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .info-msg {
    background-color: khaki;
    padding: 5px 15px;
    display: block;
    text-align: center;
  }
  .text-red {
    color: #f00;
  }
  img[alt='popup-thumb'] {
    max-height: 150px;
  }
</style>



// WEBPACK FOOTER //
// NovoPopup.vue?f6db48ee